import {View, createContext, m} from '@codeurs/front'

import {Filter} from 'util/filter'

export const FiltersContext = createContext()

export class Filters<T> extends View<{
	filter: Filter<T>
	style: 'aside' | 'category' | 'theme'
}> {
	render = this.render

	view() {
		const {children, filter, style} = this.attrs
		return m(FiltersContext.Provider, {value: {filter, style}}, children)
	}
}
